import React from 'react';
import { motion } from 'framer-motion';
export function Welcome() {
  return <section className="bg-white text-zinc-900 py-32 md:py-48 px-6" data-id="element-85">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-86">
        {/* Top divider */}
        <div className="w-16 h-px bg-zinc-200" data-id="element-87" />

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="py-16 md:py-20" data-id="element-88">
          <span className="block font-mono text-[11px] md:text-xs uppercase tracking-[0.35em] text-zinc-400 mb-8" data-id="element-89">
            Bienvenidos
          </span>

          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light uppercase tracking-tight leading-[1.1] text-zinc-900" data-id="element-90">
            Una nueva experiencia
            <br className="hidden md:block" data-id="element-91" /> está en camino
          </h2>

          <p className="mt-10 text-lg md:text-xl font-light leading-relaxed text-zinc-500 max-w-2xl mx-auto" data-id="element-92">
            Mientras finalizamos nuestra nueva plataforma, aquí encontrarás
            nuestras próximas expediciones y programas de formación disponibles.
          </p>
        </motion.div>

        {/* Bottom divider */}
        <div className="w-16 h-px bg-zinc-200" data-id="element-93" />
      </div>
    </section>;
}